import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import FormField from "../common/form/FormField";
import { numberMask, phoneMask, noSpace } from "../../tools/mask";
import logo from '../../../img/logo.svg'
import AuthStepCode from './AuthStepCode';
import RegEcp from './RegEcp';
import desk_inst from '../../../document/desktop_ins.pdf'
import AuthFormMain from './AuthFormMain';
import FormToggle from './FormToggle';
import DsBlock from './DsBlock';
import ByNumberForm from './ByNumberForm';

export default class Auth extends Component {
    constructor(props, context) {
        super(props, context);

        const switcher = (this.props.switcher) !== undefined
            ? this.props.switcher
            : false;

        this.state = {
            time: 0,
            fieldsAuth: {
                phone_number: {
                    type: 'phone_number',
                    label: "Номер телефона",
                    name: "authPhone",
                    value: "",
                    placeholder: '+7 (___) ___-__-__',
                    // required: true,
                    error: '',
                    mask: phoneMask,
                    ref: (input) => {
                        this.phoneInput = input;
                    }
                },
                password: {
                    type: 'password',
                    label: "Пароль",
                    name: "authPassword",
                    value: "",
                    // required: true,
                    error: '',
                    mask: noSpace,
                    ref: (input) => {
                        this.passwordInput = input;
                    }
                }
            },
            fieldsEc: {
                digitalSignature: {
                    type: 'select-diadoc',
                    label: "Выберите электронную подпись",
                    placeholder: "Выберите подпись",
                    name: "ecp",
                    value: "",
                    options: [],
                    // required: true,
                    error: '',
                },
            },
            fieldsCodevalidate: {
                code: {
                    type: 'text',
                    label: "Введите код подтверждения, отправленный Вам в SMS:",
                    name: "authCode",
                    value: "",
                    // required: true,
                    error: '',
                    mask: numberMask(4),
                    min: 4,
                    ref: (input) => {
                        this.codeInput = input;
                    }
                }
            },
            autoFilled: [],
            switcher, 
            disabled: false,
        };

    }

    componentDidMount() {
        this.props.regReset();
        this.phoneInput && this.phoneInput.addEventListener("transitionend", () => {
            var autoFilled = [...this.state.autoFilled];
            autoFilled.push('phone_number');
            this.setState({ autoFilled });
        }, false);

        this.passwordInput && this.passwordInput.addEventListener("transitionend", () => {
            var autoFilled = [...this.state.autoFilled];
            autoFilled.push('password');
            this.setState({ autoFilled });
        }, false);


    }

    componentDidUpdate(prevProps) {
        const { diadocState } = this.props;

        if (prevProps.diadocState !== diadocState) {
            this.setState(prevState => ({
                fieldsEc: {
                    ...prevState.fieldsEc,
                    digitalSignature: {
                        ...prevState.fieldsEc.digitalSignature,
                        options: this.props.diadocState.userCertificate
                    }
                }
            }));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.authErrors != nextProps.authErrors) {
            var state = { ...this.state };
            for (var attr in state.fieldsAuth) {
                state.fieldsAuth[attr].error = nextProps.authErrors[attr] || ''
            }
            this.setState(state);
        }
        if (this.props.codevalidateErrors != nextProps.codevalidateErrors) {
            var state = { ...this.state };
            for (var attr in state.fieldsCodevalidate) {
                state.fieldsCodevalidate[attr].error = nextProps.codevalidateErrors[attr] || ''
            }
            this.setState(state);
        }
        if ((this.props.step != nextProps.step) && nextProps.step === 2) {
            clearInterval(this.timer);
            this.setState({ time: 30 }, () => {
                this.timer = setInterval(this.setTime, 1000);
            });
        }
        if (this.props.triesMore != nextProps.triesMore) {
            clearInterval(this.timer);
            this.setState({ time: 30 }, () => {
                this.timer = setInterval(this.setTime, 1000);
            });
        }
        if (this.props.fields.code != nextProps.fields.code) {
            this.setState({
                fieldsCodevalidate: {
                    code: {
                        ...this.state.fieldsCodevalidate.code,
                        value: nextProps.fields.code
                    }
                }
            });
        }
    }

    componentWillUnmount = () => {
        clearInterval(this.timer);
    }

    static contextTypes = {
        screenSize: PropTypes.string,
        currentLanguage: PropTypes.object,
        translate: PropTypes.func
    };

    funcState = (prevState) => {
        if (this.state.time < 1) {
            clearInterval(this.timer);
            return { time: 0 };
        }
        var timer = --prevState.time;
        if (timer < 10) timer = '0' + (timer.toString());
        return { time: timer };
    };

    setTime = () => {
        this.setState(this.funcState);
    };


    onChangeField = (name) => {
        return (attribute, value, error, selectionStart) => {
            var prevState = { ...this.state[name] };
            if (prevState.hasOwnProperty(attribute)) {
                prevState[attribute].value = value;
                prevState[attribute].error = error;
                this.setState({
                    ...this.state,
                    [name]: prevState,
                    autoFilled: []
                }, () => {
                    if (attribute == 'phone_number' && selectionStart) {
                        this.phoneInput.selectionStart = this.phoneInput.selectionEnd;
                    }
                })
            }
        }
    };

    onCodeRequest = () => {
        var {
            phone_number,
            password
        } = this.state.fieldsAuth;

        // this.codeRequestBtn.focus();

        this.props.onCodeRequest && this.props.onCodeRequest(phone_number.value, password.value);
    }

    onRepeatCodeRequest = (e) => {
        e.preventDefault();

        this.setState({ time: 30 }, () => {
            this.timer = setInterval(this.setTime, 1000);
            this.onCodeRequest();
        });
    }

    onCodeValidate = () => {
        this.props.onCodeValidate && this.props.onCodeValidate(this.state.fieldsAuth.phone_number.value, this.state.fieldsCodevalidate.code.value);
    }

    isValid = (name) => {
        if (this.state.autoFilled.length == 2) return true;
        var fields = { ...this.state[name] };
        for (var attr in fields) {
            if (fields[attr].error || fields[attr].required && !fields[attr].value) return false;
        }
        return true;
    }

    changePassType = (passType) => {
        this.setState({
            fieldsAuth: {
                ...this.state.fieldsAuth,
                password: {
                    ...this.state.fieldsAuth.password,
                    type: passType
                }
            }
        })
    }


    renderFields = (fields, name) => {
        var result = [];

        for (var attribute in fields) {
            if (fields.hasOwnProperty(attribute)) {

                result.push(<div className="form__row reg" key={name + attribute}>
                    <FormField
                        fieldConfig={{ ...fields[attribute], label: this.context.translate(fields[attribute].label) }}
                        attribute={attribute}
                        onChange={this.onChangeField(name)}
                        changePassType={this.changePassType}
                        isRegPage
                    />
                </div>)
            }
        }

        return result;
    };

    onSelecSignature = (attribute, value) => {
        this.setState(prevState => ({
            fieldsEc: {
                ...prevState.fieldsEc,
                digitalSignature: {
                    ...prevState.fieldsEc.digitalSignature,
                    value: value
                }
            }
        }));
        this.props.getCerfInfoAction(value)
    };

    onAuthByEcpSubmit = () => {
        this.setState(prevState => ({
            disabled: true,
        }))
        const cerfInfo = JSON.stringify({ requestTime: new Date(Date.now()) })
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(cerfInfo);
        const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
        this.props.signCertificateAction(this.state.fieldsEc.digitalSignature.value, base64String)
        this.props.checkSignature(cerfInfo)
    }

    hanldeRegByDs = () => {
        this.props.regByDsAct(true)
        localStorage.setItem('regByDs', true)
    }
    hanldeAuthByDs = () => {
        this.props.authByDsAct(true)
        localStorage.setItem('authByDs', true)
    }
    render() {

        let {
            fieldsAuth,
            fieldsCodevalidate,
            time,
            switcher,
            fieldsEc,
            disabled,
        } = this.state;

        let {
            step,
            triesMore,
            toCodeRequest,
            sendRequest,
            errorUserNotFound,
            authByDs,
            authByDsAct,
            regByDsAct,
            pageSettings,
        } = this.props;
        return (
            <Fragment>
                {authByDs ? <RegEcp
                    onSelecSignature={this.onSelecSignature}
                    onSubmit={this.onAuthByEcpSubmit}
                    diadocState={this.props.diadocState}
                    getUserCertificatesAction={this.props.getUserCertificatesAction}
                    getCerfInfoAction={this.props.getCerfInfoAction}
                    regByDs={this.props.regByDs}
                    regByDsAct={regByDsAct}
                    authByDsAct={authByDsAct}
                    authByDs={authByDs}
                    fieldsEc={fieldsEc}
                    disabled={disabled}
                />
                    :

                    <div className={'auth__main__page' + (step == 2 ? ' step_code' : '')}>
                        {step == 1 &&
                            <div className='auth__page__intro'>
                                <div>
                                    <h1>{pageSettings.intro_title[this.context.currentLanguage.alias]}</h1>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: pageSettings.intro_body[this.context.currentLanguage.alias] }}
                                    />
                                </div>
                            </div>
                        }

                        {step == 2 &&
                            <div className='auth__form__step__code'>
                                <AuthStepCode
                                    onCodeValidate={this.onCodeValidate}
                                    renderFields={this.renderFields}
                                    triesMore={triesMore}
                                    step={step}
                                    onRepeatCodeRequest={this.onRepeatCodeRequest}
                                    toCodeRequest={toCodeRequest}
                                    time={time}
                                    fieldsCodevalidate={fieldsCodevalidate}
                                    context={this.context}
                                    isValid={this.isValid}
                                    sendRequest={sendRequest}
                                />
                            </div>
                        }
                        {step != 2 &&
                            <div className="auth__form">
                                <div className={"auth__form-slide" + (step != 2 ? " active" : "")}
                                >
                                    <FormToggle
                                        shownPass={this.shownPass}
                                        setState={this.setState}
                                        onAuth={() => this.setState({ switcher: false })}
                                        onReg={() => this.setState({ switcher: true })}
                                        isValid={this.isValid}
                                        codeRequestBtn={this.codeRequestBtn}
                                        context={this.context}
                                        switcher={switcher}
                                        sendRequest={sendRequest}
                                        logo={logo}
                                    />

                                    <DsBlock
                                        switcher={this.state.switcher}
                                        hanldeRegByDs={this.hanldeRegByDs}
                                        hanldeAuthByDs={this.hanldeAuthByDs}
                                        instruction={desk_inst}
                                    />

                                    <div className='divider'>
                                        <span>или</span>
                                    </div>

                                    {this.state.switcher ?
                                        <ByNumberForm translate={this.context.translate} />
                                        :
                                        <AuthFormMain
                                            onCodeRequest={this.onCodeRequest}
                                            renderFields={this.renderFields}
                                            translate={this.context.translate}
                                            isValid={this.isValid}
                                            numberValue={this.state.fieldsAuth.phone_number.value}
                                            passwordValue={this.state.fieldsAuth.password.value}
                                            codeRequestBtn={this.codeRequestBtn}
                                            fieldsAuth={fieldsAuth}
                                            sendRequest={sendRequest}
                                            errorUserNotFound={errorUserNotFound} />
                                    }
                                    <div className="auth__subtext">
                                        <p className='subtitle'>Возникла проблема?</p>
                                        <p>{this.context.translate("Звоните ")}
                                            <a target="_blank"
                                                href={this.props.pageSettings.support_phone[this.context.currentLanguage.alias] ? "tel:" + (this.props.pageSettings.support_phone[this.context.currentLanguage.alias].replace(/\s/g, '')) : "#"}>{
                                                    this.props.pageSettings &&
                                                    this.props.pageSettings.support_phone &&
                                                    this.props.pageSettings.support_phone[this.context.currentLanguage.alias]
                                                }</a>
                                            {this.context.translate(" или вашему менеджеру")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </Fragment >
        )
    }
}